import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1be1a3b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-bank-account-modal" }
const _hoisted_2 = { class: "bank-account-grid-container" }
const _hoisted_3 = { class: "amount-cell" }

import { computed, watch, ref, onMounted } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import { BankAccountCompany } from "@/types/accounts/BankAccountCompany";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import { formatNumberIntoCurrency } from "@/utils/CurrencyFormatter";
import { useAccountHelper } from "@/utils/accounts/useAccountHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'select-bank-account-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Triggered when a bank account is selected so that the it can be used in the process tenant payments modal.
   */
  "bankAccountSelected",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const companies = ref<BankAccountCompany[]>([]);
const selectedPayment = ref<BankAccountCompany>();
const loading = ref(false);
const currentUserStore = useCurrentUserStore();
const currentUser = ref<CurrentUser>();
const accountHelper = useAccountHelper();

onMounted(async () => {
  currentUser.value = await currentUserStore.getCurrentUserDetails();
});

watch(
  () => showModal.value,
  async () => {
    if (!showModal.value) {
      return;
    }

    loading.value = true;
    companies.value = await accountHelper.fetchCompanies();
    loading.value = false;
  },
);

const onRowSelected = (e: BankAccountCompany) => {
  if (!e) {
    return;
  }

  selectedPayment.value = e;
};

const onRowClick = (e: BankAccountCompany) => {
  if (!e) {
    return;
  }

  selectedPayment.value = e;
  emit("bankAccountSelected", selectedPayment.value.bankAccountId);
  showModal.value = false;
};

const onCancelClick = () => (showModal.value = false);

const onSelectClick = () => {
  emit("bankAccountSelected", selectedPayment.value?.bankAccountId);
  showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    title: "Select Bank Account",
    height: "350px"
  }, {
    "non-scrollable-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(GridBase, {
            "data-source": companies.value,
            "id-column-name": "bankAccountId",
            loading: loading.value,
            "show-action-button": true,
            "column-auto-width": true,
            onRowClick: onRowClick,
            onAdaptiveRowSelection: onRowSelected,
            onRowSelected: onRowSelected,
            wordWrapEnabled: true,
            "show-search-panel": false,
            customColumnSlots: ['amountCell']
          }, {
            columns: _withCtx(() => [
              _createVNode(_unref(DxColumn), {
                "data-field": "bankAccountId",
                caption: "ID",
                visible: false
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "companyName",
                caption: "Company",
                width: 150,
                "hiding-priority": 3
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "bankAccountDescription",
                caption: "Bank Account",
                "hiding-priority": 2
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "amount",
                caption: "Amount",
                "hiding-priority": 1,
                width: 100,
                "cell-template": "amountCell"
              })
            ]),
            amountCellData: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(formatNumberIntoCurrency)(
                    data.amount,
                    currentUser.value?.countryCodeID,
                  )), 1)
            ]),
            _: 1
          }, 8, ["data-source", "loading"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Select',
          onClick: () => {
            onSelectClick();
          },
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})